// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_orthohouse_part_of = /** @type {(inputs: {}) => string} */ () => {
	return `Part of OrthoHouse`
};

const el_orthohouse_part_of = /** @type {(inputs: {}) => string} */ () => {
	return `Ανήκει στην OrthoHouse`
};

const ru_orthohouse_part_of = /** @type {(inputs: {}) => string} */ () => {
	return `Часть OrthoHouse`
};

const he_orthohouse_part_of = /** @type {(inputs: {}) => string} */ () => {
	return `חלק מ־OrthoHouse`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const orthohouse_part_of = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.orthohouse_part_of(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("orthohouse_part_of", locale)
	if (locale === "en") return en_orthohouse_part_of(inputs)
	if (locale === "el") return el_orthohouse_part_of(inputs)
	if (locale === "ru") return ru_orthohouse_part_of(inputs)
	if (locale === "he") return he_orthohouse_part_of(inputs)
	return "orthohouse_part_of"
};